<template>
  <div>
    <div
      class="max-w-5xl mx-auto relative py-10 px-4 list-widget-wrapper"
      v-if="reviewMeta.locationName"
      :style="cssProps"
    >
      <div
        class="p-4 flex justify-between items-center mb-4 rounded-lg flex-col sm:flex-row"
      >
        <div>
          <h2 class="text-xl font-semibold">
            {{ reviewMeta.locationName }}
          </h2>
          <div class="flex items-center mt-1">
            <span class="text-3xl font-bold mr-2">{{
              reviewMeta.averageRating.toFixed(1)
            }}</span>
            <div class="text-yellow-400 text-xl header-stars">
              <span v-for="i in 5" :key="i" class="star">
                ★
              </span>
            </div>
            <span class="ml-2 text-sm" v-if="config && config.listConfig"
              >{{ reviewMeta.totalReviewCount }}
              {{ config.listConfig.reviewCountLabel || "reviews" }}</span
            >
            <img
              v-if="config.carouselConfig.showGoogleImage"
              src="https://configs.carthike.com/googlereviews/googleimage.png"
              alt="Google Logo"
              class="h-5 ml-2"
            />
          </div>
        </div>
        <a
          v-if="config && config.listConfig"
          :href="reviewMeta.newReviewUri"
          target="_blank"
          class="text-white px-4 py-2 rounded transition write-review-button"
          >{{ config.listConfig.reviewButtonLabel || "Leave a review" }}</a
        >
      </div>
      <div class="space-y-4">
        <div
          class="w-full p-6 rounded-lg shadow-sm review-card"
          v-for="(review, index) of displayedReviews"
          :key="index"
        >
          <div class="flex items-start space-x-4">
            <img
              :src="review.reviewer.profilePhotoUrl"
              referrerpolicy="no-referrer"
              alt="Review image"
              class="w-10 h-10 rounded-full"
            />
            <div class="flex-1">
              <h3 class="font-medium text-base mb-1">
                {{ review.reviewer.displayName }}
              </h3>
              <div class="flex items-center space-x-3 mb-2">
                <div class="flex">
                  <span class="text-lg rating-stars">
                    <span v-for="index in review.starRating" :key="index"
                      >★</span
                    >
                  </span>
                </div>
                <span class="text-sm text-gray-600">{{
                  review.createReviewTime | dateFilter
                }}</span>
              </div>
              <p class="text-sm leading-relaxed">
                {{ review.comment ? review.comment : "" }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasMoreReviews" class="mt-6 text-center">
        <button
          @click="loadMore"
          class="px-6 py-2 rounded transition write-review-button text-white"
        >
          {{ config.listConfig.loadMoreButtonLabel || "Load More Reviews" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {},
  data() {
    return {
      reviewMeta: {},
      reviews: {},
      currentPage: 1,
      itemsPerPage: 3,
      defaultReviewMeta: {
        newReviewUri: "https://google.com",
        averageRating: 4.599999904632568,
        totalReviewCount: 14,
        locationName: "Sample Company"
      },
      defaultReviews: {
        docs: [
          {
            _id: "sample1",
            reviewId: "review1",
            storeId: "store123",
            __v: 0,
            comment:
              "Great service and amazing products! The team was very helpful and professional. Would definitely recommend to others.",
            createReviewTime: 1710910638,
            createdAt: 1720198612,
            name: "accounts/sample/review1",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "John Smith",
              _id: "reviewer1"
            },
            starRating: 5,
            updateReviewTime: 1710910638,
            updatedAt: 1722620725,
            id: "sample1"
          },
          {
            _id: "sample2",
            reviewId: "review2",
            storeId: "store123",
            __v: 0,
            comment:
              "Had some issues with delivery but customer service resolved them quickly. Product quality is good.",
            createReviewTime: 1708224237,
            createdAt: 1720198612,
            name: "accounts/sample/review2",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "Mary Johnson",
              _id: "reviewer2"
            },
            starRating: 4,
            updateReviewTime: 1708224237,
            updatedAt: 1722620727,
            id: "sample2"
          },
          {
            _id: "sample3",
            reviewId: "review3",
            storeId: "store123",
            __v: 0,
            comment:
              "Excellent experience overall. Fast shipping and great communication throughout.",
            createReviewTime: 1669713601,
            createdAt: 1720198612,
            name: "accounts/sample/review3",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "Robert Wilson",
              _id: "reviewer3"
            },
            starRating: 5,
            updateReviewTime: 1669713601,
            updatedAt: 1722620728,
            id: "sample3"
          },
          {
            _id: "sample4",
            reviewId: "review4",
            storeId: "store123",
            __v: 0,
            comment:
              "Product was okay but a bit overpriced compared to competitors.",
            createReviewTime: 1651348206,
            createdAt: 1720198612,
            name: "accounts/sample/review4",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "Sarah Brown",
              _id: "reviewer4"
            },
            starRating: 3,
            updateReviewTime: 1651348206,
            updatedAt: 1722620730,
            id: "sample4"
          },
          {
            _id: "sample5",
            reviewId: "review5",
            storeId: "store123",
            __v: 0,
            comment:
              "Fantastic product and amazing value for money. Will definitely buy again!",
            createReviewTime: 1616054200,
            createdAt: 1720198612,
            name: "accounts/sample/review5",
            reviewer: {
              profilePhotoUrl:
                "https://lh3.googleusercontent.com/a/ACg8ocK7S7bGVFA-5fztrseDQj2RB536D4xiZ5kH-RGD46VN81v-JA=s120-c-rp-mo-br100",
              displayName: "James Davis",
              _id: "reviewer5"
            },
            starRating: 5,
            updateReviewTime: 1616054200,
            updatedAt: 1722620731,
            id: "sample5"
          }
        ],
        total: 5,
        limit: 5
      }
    };
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    cssProps() {
      return {
        "--list-widget-card-background-color": `${this.config.listConfig.cardBackgroundColor}`,
        "--list-widget-stars-color": `${this.config.listConfig.starColor}`,
        "--list-widget-text-color": `${this.config.listConfig.textColor}`,
        "--list-widget-button-background-color": `${this.config.listConfig.buttonBackgroundColor}`,
        "--list-widget-container-background-color": `${this.config.listConfig.containerBackgroundColor}`
      };
    },
    displayedReviews() {
      return this.reviews.docs
        ? this.reviews.docs.slice(0, this.currentPage * this.itemsPerPage)
        : [];
    },
    hasMoreReviews() {
      return (
        this.reviews.docs &&
        this.currentPage * this.itemsPerPage < this.reviews.docs.length
      );
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const store = this.$store.getters.getStore;
      this.$store
        .dispatch("getPublicReviews", { shop: store.shopOrigin })
        .then(response => {
          if (response.reviewMeta) {
            this.reviewMeta = response.reviewMeta;
            this.reviews = response.reviews;
          } else {
            this.reviewMeta = this.defaultReviewMeta;
            this.reviews = this.defaultReviews;
          }
        });
    },
    loadMore() {
      this.currentPage += 1;
    },
    scrollCarousel(direction) {
      const carousel = document.getElementById("carousel");
      const scrollAmount = direction * 272;
      carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.list-widget-wrapper {
  background: var(--list-widget-container-background-color);
  color: var(--list-widget-text-color);
}
.review-card {
  background: var(--list-widget-card-background-color);
  color: var(--list-widget-text-color);
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.rating-stars {
  color: var(--list-widget-stars-color);
  letter-spacing: 2px;
}
.header-stars {
  color: #fdd835;  /* Google's yellow star color */
}
.write-review-button {
  background: var(--list-widget-button-background-color);
}
</style>
